import { render } from "./PasswordForgetDialog.vue?vue&type=template&id=67289a9e&scoped=true&ts=true"
import script from "./PasswordForgetDialog.vue?vue&type=script&lang=ts"
export * from "./PasswordForgetDialog.vue?vue&type=script&lang=ts"

import "./PasswordForgetDialog.vue?vue&type=style&index=0&id=67289a9e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67289a9e"]])

export default __exports__